module.exports = __webpack_public_path__ + "1d54206d825cd3ac5c67969fc9f3dfee.ico";